import { combineReducers } from 'redux'

import { reducer as Reestimate, constants as ReestimateConstants } from './Tabs/PreciousMetals/Reestimate'

export default combineReducers({
  [ReestimateConstants.REDUCER_NAME]: Reestimate,
})
